module.exports = __webpack_public_path__ + "img/multibanco.72ae4795.svg";